<template>
<div>
 <!-- Two-way Data-Binding -->
  <quill-editor
    ref="myQuillEditor"
    v-model="content"
    :options="editorOption"
    @blur="onEditorBlur($event)"
    @focus="onEditorFocus($event)"
    @ready="onEditorReady($event)"
    @change="onEditorChange($event)"
    @keydown="onKeyDown($event)"
    :disabled = 'disabled'
  />
  <p class="eidotr-text" v-if="!!maxLength">
      <span>{{ currentLength }}</span>
      <span>/</span>
      <span>{{ maxLength }}</span>
    </p>

  <!-- <form action method="post" enctype="multipart/form-data" id="uploadFormMulti">
      <input
        style="display: none"
        :id="uniqueId"
        type="file"
        name="file"
        multiple
        accept="image/jpg, image/jpeg, image/png, image/gif"
        @change="uploadImg('uploadFormMulti')"
      />
    </form> -->
</div>
</template>

<script>
import { quillEditor } from "vue-quill-editor";

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'


export default {
    name:'QuillEditor',
    components: {
        quillEditor
    },
    props: {
    // 这里可以定义传递给组件的属性，比如初始值、配置等
    value: {
      type: String,
      default: ''
    },
    maxLength: {
      type: Number,
      default: 2000,
    },
    disabled:{
      type: Boolean,
      default: false
    }
    },
   data () {
      return {
        // 富文本编辑器默认内容
        content: this.value,
        //富文本编辑器配置
        editorOption: {
          // Some Quill options...
          theme: "snow",
          placeholder: "请输入正文"
        },
        currentLength:0
      }
    },
    watch: {
    // 监听value的变化，并同步到editorContent
    value(newVal) {
      this.content = newVal;
    },
    content(newVal) {
      // 当编辑器内容变化时，使用$emit触发input事件，将内容传递出去
      this.$emit('input', newVal);
    }
  },
  mounted(){
    this.currentLength = this.$refs.myQuillEditor.quill.getLength() - 1
  },

    methods: {
      handleTextChange(delta, oldDelta, source) {
      // 你的处理逻辑
      console.log('Text changed:', delta);
    },
      //失去焦点事件
      onEditorBlur(quill) {
        console.log('editor blur!', quill)
      },
      //获得焦点事件
      onEditorFocus(quill) {
        console.log('editor focus!', quill)
      },
      // 准备富文本编辑器
      onEditorReady(quill) {
        console.log('editor ready!', quill)
      },
      //内容改变事件
      onEditorChange({quill,html,text}) {
        console.log('editor change!',quill,html,text)
        this.content = html
       //console.log('我改变了')
        this.currentLength = text.length-1
      },

      //上传图片等文件
      uploadImg: async function() {
      var _this = this;
      //构造formData对象
      var formData = new FormData();
      formData.append("file", document.getElementById(_this.uniqueId).files[0]);

      try {
        //调用上传文件接口
        this.$http.productapi.uploadImgReq(formData).then(res => {
          //返回上传文件的地址
          let url = res;
          if (url != null && url.length > 0) {
            let Range = _this.editor.getSelection();
            url = url.indexOf("http") != -1 ? url : "http:" + url;
            //上传文件成功之后在富文本中回显(显示)
            _this.editor.insertEmbed(
              Range != null ? Range.index : 0,
              "image",
              url
            );
          } else {
            _this.$message.warning("图片上传失败");
          }
          //成功之后,将文件的文本框的value置空
          document.getElementById(_this.uniqueId).value = "";
        });
      } catch ({ message: msg }) {
        document.getElementById(_this.uniqueId).value = "";
        _this.$message.warning(msg);
      }
    }
  },

}



</script>
<style scoped>
.quill-editor /deep/ .ql-container {
    height: 220px;
    position: relative;
  }

  .ql-container {
    height: 230px;
    overflow-y: scroll;
  }
  .eidotr-text {
    position: absolute;
    right: 8px;
    bottom: 4px;
    font-size: 14px;
    text-shadow: 0px 0px 1px #fff;
  }




</style>



// WEBPACK FOOTER //
// src/landmark-user/components/QuillEditor.vue